export default {
  app: {
    brand: 'Retro Arcade',
    tagline: 'Nostalgic Retro Mini-Games',
    pressStart: '▶ PRESS START TO CONTINUE',
    footer: 'Retro Arcade · Built with Vue 3 + Phaser.js',
  },
  nav: {
    home: 'Home',
    games: 'All Games',
    ranks: 'Leaderboard',
    profile: 'Me',
    login: 'Log In',
    logout: 'Log Out',
    register: 'Register',
  },
  home: {
    featured: 'Featured',
    released: 'Released',
    coming: 'Coming Soon',
    coming_soon: 'COMING SOON',
    categories: 'Categories',
    news: 'News',
    start: '▶ Start',
    ranks: '🏆 Rankings',
    play: '▶ Play',
    details: 'Details',
  },
  games: {
    title: 'Games Library ({count})',
    search: 'Search games...',
    all: 'All',
    released: 'Released',
    coming: 'Coming Soon',
    loading: 'Loading...',
    no_result: 'No games found...',
    controls: 'Controls',
    play: '▶ Play',
    lock: '🔒 Coming Soon',
    play_disabled: 'Details',
    author: 'Author: {name}',
  },
  rank: {
    title: '🏆 Leaderboard',
    subtitle: 'TOP PLAYERS',
    filter_all: 'All',
    rank: '#',
    user: 'Player',
    game: 'Game',
    score: 'Score',
    loading: 'Loading...',
    empty: 'No scores yet, be the first to play!',
    refresh: 'Refresh',
  },
  profile: {
    title: '👤 Profile',
    login_first: 'Please log in to view',
    history: '🎮 My Scores ({count})',
    no_score: 'No scores yet, play a game to get started ~',
    loading: '📊 Loading...',
    date: 'Date',
    score: 'Score',
    settings: '⚙ Settings',
    achievements: '🏆 Achievements: {unlocked}/{total}',
  },
  auth: {
    login_title: 'LOGIN',
    login_sub: 'SIGN IN TO SAVE YOUR PROGRESS',
    register_title: 'REGISTER',
    register_sub: 'CREATE YOUR PLAYER ACCOUNT',
    user: 'USER',
    pass: 'PASS',
    confirm: 'CONFIRM',
    login_btn: '▶ Log In',
    register_btn: '▶ Register',
    no_account: "Don't have an account?",
    has_account: 'Already have an account?',
    goto_register: 'Register →',
    login_success: 'Login successful!',
    register_success: 'Registration successful, logging in...',
  },
  settings: {
    title: '⚙ SETTINGS',
    crt: 'CRT filter',
    reduce_motion: 'Reduce motion',
    pixel_scale: 'Pixel scale',
    theme: 'Theme',
    leaderboard_limit: 'Default rows',
    auto_submit: 'Auto submit score',
    reset: 'Reset to defaults',
  },
  game: {
    exit: 'Exit',
    loading: 'LOADING...',
    error_load: 'Failed to load',
    back_to_list: 'Back to Games',
    tips: '💡 TIP: Arrow / WASD to control · P pause · R restart',
    tips_mobile: 'Please use the virtual dpad below',
    paused: '⏸ PAUSED',
    continue: 'Press P to continue',
    gameover: 'GAME OVER',
    retry: '▶ Retry',
    win: 'YOU WIN!',
    click_retry: 'Click to retry',
    gameplay: 'How to Play',
    dev_notes: 'Dev Notes',
  },
  achievements: {
    unlocked: '🏆 Achievement Unlocked!',
    first_play: 'First Step',
    first_play_desc: 'Play any game in Retro Arcade',
    all_games: 'All Rounder',
    all_games_desc: 'Try every game',
    rank_top10: 'Rising Star',
    rank_top10_desc: 'Reach top 10 on any leaderboard',
    // snake
    snake_novice: 'Baby Snake',
    snake_novice_desc: 'Snake: 50 points',
    snake_skilled: 'Quick Snake',
    snake_skilled_desc: 'Snake: 150 points',
    snake_master: 'Snake King',
    snake_master_desc: 'Snake: 300 points',
    // tetris
    tetris_line: 'First Clear',
    tetris_line_desc: 'Tetris: clear one line',
    tetris_tspin: 'Combo Master',
    tetris_tspin_desc: 'Tetris: Tetris (clear 4 lines at once)',
    tetris_1k: 'Score Hunter',
    tetris_1k_desc: 'Tetris: 1000+ points',
    // flappy
    flappy_first: 'First Flight',
    flappy_first_desc: 'Flappy Bird: take your first flight',
    flappy_10: 'Sky Rider',
    flappy_10_desc: 'Flappy Bird: 10 points',
    flappy_50: 'Bird Master',
    flappy_50_desc: 'Flappy Bird: 50 points',
    // 2048
    '2048_128': 'Starter',
    '2048_128_desc': '2048: reach 128',
    '2048_512': 'Strategist',
    '2048_512_desc': '2048: reach 512',
    '2048_2048': '2048 Champion',
    '2048_2048_desc': '2048: achieve 2048 and win!',
    // minesweeper
    mine_clear_easy: 'Mine Novice',
    mine_clear_easy_desc: 'Minesweeper: win on easy',
    mine_clear_medium: 'Mine Expert',
    mine_clear_medium_desc: 'Minesweeper: win on medium',
    mine_clear_hard: 'Mine Master',
    mine_clear_hard_desc: 'Minesweeper: win on hard',
  },
  not_found: {
    title: '404',
    subtitle: 'PAGE NOT FOUND',
    desc: 'You have wandered out of the game map...',
    back: '▶ Back to Home',
  },
  date: {
    just_now: 'just now',
    minutes_ago: '{n} minutes ago',
    hours_ago: '{n} hours ago',
    days_ago: '{n} days ago',
  },
}
